/* ============================================
   DUDUK THEME - Main JavaScript
   Spacing Imagination
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ============================================
  // 0. GLOBAL PRICE FORMAT — strip .00 from all prices
  // ============================================
  function formatINR(paise) {
    const rupees = Math.round(paise / 100);
    return '₹' + rupees.toLocaleString('en-IN');
  }

  // Strip .00 from any server-rendered price text
  document.querySelectorAll(
    '.product-price, .product-main-price, .product-original-price, ' +
    '.price-summary-total, .cart-total-price, .cart-item-price, ' +
    '.cart-subtotal span, .product-card .product-price, .addon-price'
  ).forEach(el => {
    el.textContent = el.textContent.replace(/\.00\b/g, '');
  });

  // ============================================
  // 1. HEADER SCROLL BEHAVIOR
  // ============================================
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ============================================
  // 2. NAV COLOR WASH (Desktop hover effect)
  // ============================================
  const colorWash = document.getElementById('nav-color-wash');
  const catColors = {
    playhouses: 'rgba(255, 65, 73, 0.06)',
    decor:      'rgba(112, 141, 255, 0.06)',
    furniture:  'rgba(73, 198, 100, 0.06)',
    diy:        'rgba(255, 220, 63, 0.06)',
  };

  document.querySelectorAll('.nav-item[data-cat]').forEach(item => {
    const cat = item.dataset.cat;
    item.addEventListener('mouseenter', () => {
      if (colorWash) {
        colorWash.style.background = catColors[cat] || 'transparent';
        colorWash.style.opacity = '1';
      }
    });
    item.addEventListener('mouseleave', () => {
      if (colorWash) colorWash.style.opacity = '0';
    });
  });

  // ============================================
  // 3. MOBILE NAV DRAWER
  // ============================================
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileOverlay = document.querySelector('.mobile-nav-overlay');
  const mobileClose = document.querySelector('.mobile-nav-close');

  function openMobileNav() {
    mobileNav?.classList.add('open');
    mobileOverlay?.classList.add('visible');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    mobileNav?.classList.remove('open');
    mobileOverlay?.classList.remove('visible');
    document.body.style.overflow = '';
  }

  hamburger?.addEventListener('click', openMobileNav);
  mobileClose?.addEventListener('click', closeMobileNav);
  mobileOverlay?.addEventListener('click', closeMobileNav);

  // ============================================
  // 4. CART DRAWER
  // ============================================
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer-overlay');
  const cartClose = document.querySelector('.cart-close');

  function openCart() {
    cartDrawer?.classList.add('open');
    cartOverlay?.classList.add('visible');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('visible');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-action="open-cart"], .cart-btn').forEach(btn => {
    btn.addEventListener('click', openCart);
  });
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  async function refreshCartCount() {
    try {
      const res = await fetch('/cart.js');
      const data = await res.json();
      const countEl = document.getElementById('cart-count');
      if (countEl) countEl.textContent = data.item_count;
    } catch (e) {}
  }

  // ============================================
  // 5. PRODUCT PAGE ADD-ONS
  // Price calculation is handled entirely by the inline script in
  // templates/product.liquid (the DUDUK_priceInit IIFE).
  // This section intentionally left empty to avoid conflicts.
  // ============================================

  // ATC Form — intercept submission, add add-ons via Cart API
  const atcForm = document.getElementById('product-atc-form');
  if (atcForm) {
    atcForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      const mainVariantId = atcForm.querySelector('[name="id"]')?.value;
      if (!mainVariantId) return;

      const btn = document.getElementById('atc-btn');
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; btn.style.opacity = '0.7'; }

      // Build cart items: main product + selected add-ons
      const items = [{ id: parseInt(mainVariantId), quantity: 1 }];

      document.querySelectorAll('.addon-item.selected, .addon-item.auto-selected').forEach(item => {
        const varId = (item.dataset.variantId || '').trim();
        if (varId && varId !== '' && varId !== 'undefined') {
          items.push({ id: parseInt(varId), quantity: 1 });
        }
      });

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });

        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(errData.description || 'Cart error');
        }

        // Marketing: notify pixels (snippets/pixels.liquid listens)
        try {
          const added = await res.clone().json();
          const addedItems = (added.items || []).map(i => ({
            id: i.variant_id || i.id, name: i.product_title || i.title,
            price: (i.price || 0) / 100, quantity: i.quantity || 1
          }));
          document.dispatchEvent(new CustomEvent('duduk:add_to_cart', {
            detail: {
              items: addedItems,
              value: addedItems.reduce((s, i) => s + i.price * i.quantity, 0),
              currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'INR'
            }
          }));
        } catch (trackErr) {}

        await refreshCartCount();

        if (btn) {
          btn.textContent = 'Added!';
          btn.style.background = 'var(--color-green)';
          btn.style.opacity = '1';
          setTimeout(() => {
            btn.textContent = 'Add to Cart →';
            btn.style.background = '';
            btn.disabled = false;
          }, 1600);
        }
        openCart();

      } catch (err) {
        console.warn('DUDUK Cart Error:', err.message);
        if (btn) { btn.textContent = 'Add to Cart →'; btn.style.opacity = '1'; btn.style.background = ''; btn.disabled = false; }
        // Fallback: native form submit (adds just main product)
        atcForm.submit();
      }
    });
  }

  // ============================================
  // 6. SIZE GUIDE INTERACTIVE ANIMATION
  // ============================================
  const sizeTiers = document.querySelectorAll('.size-tier');
  const sizeRoom = document.querySelector('.size-room');
  const sizeHouseSvg = document.getElementById('size-house-svg');
  const sizeRoomLabel = document.querySelector('.size-room-label');

  const sizeConfig = {
    small:  { width: '200px', height: '200px', label: '~3ft × 3ft', svgPx: 80 },
    medium: { width: '280px', height: '280px', label: '~4ft × 4ft', svgPx: 110 },
    large:  { width: '360px', height: '360px', label: '4ft+ range',  svgPx: 140 },
  };

  sizeTiers.forEach(tier => {
    tier.addEventListener('click', () => {
      sizeTiers.forEach(t => t.classList.remove('active'));
      tier.classList.add('active');
      const size = tier.dataset.size;
      const config = sizeConfig[size];
      if (sizeRoom && config) {
        sizeRoom.style.width = config.width;
        sizeRoom.style.height = config.height;
        if (sizeRoomLabel) sizeRoomLabel.textContent = config.label;
        if (sizeHouseSvg) {
          const svg = sizeHouseSvg.querySelector('svg');
          if (svg) { svg.setAttribute('width', config.svgPx); svg.setAttribute('height', config.svgPx); }
        }
      }
    });
  });

  // ============================================
  // 7. ACCORDION (Product details & FAQ)
  // ============================================
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.accordion-item.open').forEach(o => {
        o.classList.remove('open');
        o.querySelector('.accordion-trigger')?.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ============================================
  // 8. GALLERY THUMBNAILS
  // ============================================
  const galleryThumbs = document.querySelectorAll('.gallery-thumb');
  const galleryMainImg = document.querySelector('.gallery-main img');

  galleryThumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      galleryThumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const thumbSrc = thumb.querySelector('img')?.src;
      if (thumbSrc && galleryMainImg) {
        galleryMainImg.style.opacity = '0';
        galleryMainImg.style.transition = 'opacity 0.25s ease';
        setTimeout(() => {
          galleryMainImg.src = thumbSrc.replace(/\/200x200/, '/800x800');
          galleryMainImg.style.opacity = '1';
        }, 200);
      }
    });
  });

  // ============================================
  // 9. SCROLL REVEAL
  // ============================================
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(el => revealObserver.observe(el));
  }

  // ============================================
  // 10. QTY BUTTONS IN CART
  // ============================================
  document.addEventListener('click', async (e) => {
    if (!e.target.classList.contains('qty-btn')) return;
    const container = e.target.closest('.cart-item-qty');
    if (!container) return;
    const numEl = container.querySelector('.qty-num');
    const line = e.target.dataset.line;
    let qty = parseInt(numEl?.textContent) || 1;
    if (e.target.dataset.action === 'minus') qty = Math.max(0, qty - 1);
    if (e.target.dataset.action === 'plus') qty++;
    if (numEl) numEl.textContent = qty;
    if (line) {
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(line), quantity: qty })
        });
        refreshCartCount();
      } catch (err) {}
    }
  });

  // ============================================
  // 11. SMOOTH SCROLL FOR ANCHOR LINKS
  // ============================================
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const href = a.getAttribute('href');
      if (href === '#') return;
      const target = document.querySelector(href);
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  // ============================================
  // 12. KEYFRAME INJECTION
  // ============================================
  if (!document.getElementById('duduk-keyframes')) {
    const style = document.createElement('style');
    style.id = 'duduk-keyframes';
    style.textContent = `
      @keyframes float { from{transform:translateY(0)} to{transform:translateY(-10px)} }
      @keyframes spin-slow { from{transform:rotate(0)} to{transform:rotate(360deg)} }
    `;
    document.head.appendChild(style);
  }

});
